const colors = {
    primary: "#8e44ad",
    secondary: "#f8c291",
    background: "#f5f5f5",
    text: "#333333",
    accent: "#ff6b6b",
    lightPink: "#f9b9f8",
};

export default colors;
